import { useEffect, useState } from 'react'
import { api, ApiError } from '../api'
import type { ShareInfo } from '../api'

// Envio do laudo liberado ao paciente. O que vai na mensagem é o endereço do
// laudo na nuvem; para abrir, o paciente informa a data de nascimento.
export function EnviarLaudo({ reportId, onClose }: { reportId: string; onClose: () => void }) {
  const [info, setInfo] = useState<ShareInfo | null>(null)
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [copied, setCopied] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    api.reports.share(reportId)
      .then((i) => { setInfo(i); setPhone(i.phone ?? ''); setEmail(i.email ?? '') })
      .catch((err) => setError(err instanceof ApiError ? err.message : 'falha ao preparar o envio'))
  }, [reportId])

  const text = info
    ? `Olá, ${info.patient.trim().split(' ')[0]}. Seu laudo de ${info.title.toLowerCase()} (${info.clinic}) está disponível:\n${info.url}\nPara abrir, informe a data de nascimento.`
    : ''

  function whatsapp() {
    let digits = phone.replace(/\D/g, '')
    if (digits.length <= 11) digits = '55' + digits // sem código do país: Brasil
    void api.openLink(`https://wa.me/${digits}?text=${encodeURIComponent(text)}`)
  }
  function mail() {
    const subject = `Laudo de exame — ${info?.clinic ?? ''}`
    void api.openLink(`mailto:${email.trim()}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`)
  }
  async function copy() {
    if (!info) return
    try {
      await navigator.clipboard.writeText(info.url)
      setCopied(true)
    } catch {
      setError('não foi possível copiar o endereço')
    }
  }

  const phoneOk = phone.replace(/\D/g, '').length >= 10
  const emailOk = /^\S+@\S+\.\S+$/.test(email.trim())

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(8,14,18,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 60 }}>
      <div onClick={(e) => e.stopPropagation()} className="fade-in"
        style={{ width: 480, background: 'var(--surface)', border: '1px solid var(--border-2)', borderRadius: 9, boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}>
        <div style={{ padding: '13px 16px', borderBottom: '1px solid var(--border)', font: '600 14px/1.2 var(--font-sans)' }}>
          Enviar laudo{info ? ` · ${info.patient}` : ''}
        </div>

        <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {error && <div style={{ padding: '8px 11px', border: '1px solid var(--danger)', borderRadius: 6, background: 'var(--danger-soft)', fontSize: 12, color: 'var(--danger)' }}>{error}</div>}
          {info && (
            <>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                <label className="field" style={{ flex: 1 }}><span>Celular</span>
                  <input className="input" value={phone} onChange={(e) => setPhone(e.target.value)} autoFocus />
                </label>
                <button className="btn btn-primary" onClick={whatsapp} disabled={!phoneOk} style={{ height: 30, width: 110 }}>WhatsApp</button>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                <label className="field" style={{ flex: 1 }}><span>E-mail</span>
                  <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </label>
                <button className="btn btn-primary" onClick={mail} disabled={!emailOk} style={{ height: 30, width: 110 }}>E-mail</button>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ flex: 1, minWidth: 0, font: '400 11px/1.4 var(--font-mono)', color: 'var(--text-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{info.url}</div>
                <button className="btn" onClick={() => void copy()} style={{ height: 30, width: 110 }}>{copied ? 'Copiado' : 'Copiar'}</button>
              </div>
            </>
          )}
        </div>

        <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border)', background: 'var(--surface-2)', display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn" onClick={onClose} style={{ height: 31 }}>Fechar</button>
        </div>
      </div>
    </div>
  )
}
